export const DashboardSummaryWidgets = {
    total: {
        icon: 'ri-box-3-line',
        color: 'primary',
    },
    open: {
        icon: 'ri-send-plane-line',
        color: 'info',
    },
    transit: {
        icon: 'ri-truck-line',
        color: 'warning',
    },
    delivered: {
        icon: 'ri-checkbox-circle-line',
        color: 'success',
    },
    closed: {
        icon: 'ri-close-circle-line',
        color: 'danger',
    },
};

export const AttentionItemTypes = {
    manual_review: {
        icon: 'ri-alert-line',
        color: 'warning',
    },
    draft: {
        icon: 'ri-file-list-3-line',
        color: 'info',
    },
    closing_soon: {
        icon: 'ri-time-line',
        color: 'danger',
    },
};

export const ChartColors = {
    primary: '#556EE6',
    info: '#50A5F1',
    success: '#34C38F',
    warning: '#F1B44C',
    danger: '#F46A6A',
    secondary: '#74788D',
};
